<template>
  <v-container>
    <!-- Modal Loading -->
    <v-dialog persistent max-width="300" v-model="blockScreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold"
            >Aguarde, estamos processando os dados...</span
          >
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="checkin-text"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <span class="title">Reserva</span>

    <v-layout row ma-0 mt-2>
      <v-flex>
        <BuscaUsuario @selectUser="selectUser"></BuscaUsuario>
      </v-flex>
    </v-layout>

    <CadastroUsuario
      :newUser="newUser"
      :clientModelId="clientModel.id"
      @cancel="cleanFields"
    ></CadastroUsuario>

    <v-layout row ma-0 mt-2 v-if="!clientId">
      <v-flex>
        <v-autocomplete
          v-model="clientModel"
          :items="clientItems"
          :loading="isLoadingClient"
          color="blue darken-4"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          label="Cliente"
          placeholder="Digite o nome para buscar o cliente"
          return-object
        ></v-autocomplete>
      </v-flex>
    </v-layout>

    <v-layout row ma-0 mt-2 v-if="!clientId">
      <v-flex>
        <v-select
          v-model="vehicleRequestModel.reservationReason"
          :items="reservationReason"
          :loading="isLoadingReservationReason"
          color="blue darken-4"
          hide-no-data
          item-text="name"
          item-value="id"
          label="Tipo de Reserva"
          required
          @change="selecionaTipoReserva()"
          placeholder="Informe o tipo de reserva criada"
          return-object
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout row ma-0 mt-2 v-if="!clientId">
      <v-flex>
        <v-textarea
          outlined
          label="Motivo da criação da reserva"
          v-model="reservationReasonJustification"
          :disabled="!showJustification"
        >
        </v-textarea>
      </v-flex>
    </v-layout>

    <v-layout row ma-0 mt-2>
      <v-flex class="pr-3">
        <span class="subheading grey--text text--darken-2">
          Data e hora do check-in
        </span>
        <div class="inputs pa-1 mt-1 mb-3">
          <datetime
            input-id="inputDate"
            type="datetime"
            value-zone="America/Sao_Paulo"
            zone="America/Sao_Paulo"
            :min-datetime="dateNow()"
            :minute-step="10"
            v-model="vehicleRequestModel.begin_date"
          ></datetime>
        </div>
      </v-flex>
      <v-flex>
        <span class="subheading grey--text text--darken-2">
          Data e hora do check-out
        </span>
        <div class="inputs pa-1 mt-1 mb-3">
          <datetime
            input-id="inputDate"
            type="datetime"
            value-zone="America/Sao_Paulo"
            zone="America/Sao_Paulo"
            :min-datetime="dateNow()"
            :minute-step="10"
            v-model="vehicleRequestModel.end_date"
          ></datetime>
        </div>
      </v-flex>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            small
            class="my-auto ml-2 mr-0"
            @click="validateFields()"
          >
            <v-icon color="success">search</v-icon>
          </v-btn>
        </template>
        <span>Validar datas selecionadas</span>
      </v-tooltip>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-select
          label="Veículo"
          class="mr-2"
          no-data-text="Nenhum veículo encontrado"
          v-model="vehicleModel"
          :items="vehicles"
          :item-text="(item) => item.brand + ' - ' + item.plate"
          item-value="id"
          @change="selectVehicle"
          required
          return-object
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout pt-3 justify-space-between align-center>
      <v-flex md5>
        <label for="model">Preço (Reserva):</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">R$</span>
          </div>
          <money
            v-model="price_hour"
            v-bind="money"
            class="form-control"
          ></money>
        </div>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex md5>
        <label for="model">Preço (KM):</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">R$</span>
          </div>
          <money v-model="price_km" v-bind="money" class="form-control"></money>
        </div>
      </v-flex>
    </v-layout>
    <v-layout pt-3 justify-space-between align-center>
      <v-flex md5>
        <v-text-field
          type="number"
          label="KM livre"
          v-model="free_km"
          required
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-divider color="black"></v-divider>
    <v-layout>
      <v-flex xs12 md5>
        <v-select
          label="Método de pagamento"
          class="mr-2"
          no-data-text="Nenhum cartão encontrado"
          v-model="creditCardModel.id"
          :items="creditCards"
          item-text="nickname"
          item-value="id"
          @change="selecionaMetodoDePagamento()"
          required
        ></v-select>
      </v-flex>
      <v-spacer></v-spacer>

      <v-flex xs12 md5 class="input-group">
        <v-select
          :disabled="disableParcelamento"
          :items="parcelamento"
          item-text="text"
          label="Parcelar compra"
          item-value="value"
          no-data-text="Nenhum valor encontrado"
          v-model="vehicleRequestModel.installments"
          @change="validateFields()"
        ></v-select>
        <div
          class="input-group-prepend"
          style="padding-top: 12px; padding-bottom: 22px"
          v-if="!disableParcelamento"
        >
          <span class="input-group-text" id="basic-addon1">{{
            `${vehicleRequestModel.installments}x ${centsToReal2(
              convertMoneyToInteger(price_hour) /
                vehicleRequestModel.installments
            )} `
          }}</span>
        </div>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-row>
        <v-col cols="12" sm="4" md="4">
          <v-checkbox
            v-model="deposito"
            label="Depósito"
            color="primary"
            hide-details
            @change="
              (creditCardModel.id = null),
                selecionaMetodoDePagamento(),
                (creditCardModel.id = null)
            "
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-layout>
    <v-checkbox
      v-if="vehicleModel.insurance_tax != null"
      :label="insuranceTax"
      color="primary"
      hide-details
      @change="select_insurance_tax()"
    ></v-checkbox>
    <v-layout pt-3 justify-space-between align-center>
      <v-btn class="success ma-0" @click="createReservation">
        <span class="white--text">Realizar reserva</span>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import VehicleRequestController from '../../controllers/VehicleRequestController.js';
import ClientController from '../../controllers/ClientController.js';
import UserController from '../../controllers/UserController.js';
import VehicleController from '../../controllers/VehicleController';
import CreditCardController from '../../controllers/UserCreditCardController';
import CouponController from '../../controllers/CouponController';
import ConfigurationController from '../../controllers/ConfigurationController';
import NumberHelper from '../../helpers/NumberHelper';
import CadastroUsuario from '../shared/CadastroUsuario.vue';
import BuscaUsuario from '../shared/BuscaUsuario.vue';
import moment from 'moment';

export default {
  components: {
    CadastroUsuario,
    BuscaUsuario,
  },
  created() {
    this.vehicleRequestController = new VehicleRequestController(
      this.$resource
    );
    this.clientController = new ClientController(this.$resource);
    this.userController = new UserController(this.$resource);
    this.vehicleController = new VehicleController(this.$resource);
    this.creditCardController = new CreditCardController(this.$resource);
    this.configurationController = new ConfigurationController(this.$resource);
    this.couponController = new CouponController(this.$resource);
    if (this.clientId) this.clientModel.id = this.clientId;

    this.searchClients();
    this.searchReservationReason();
  },
  data() {
    return {
      options: [
        { text: 'Visa', value: 'Visa' },
        { text: 'Mastercard', value: 'Master' },
        { text: 'American Express', value: 'Amex' },
        { text: 'Elo', value: 'Elo' },
        { text: 'Aura', value: 'Aura' },
        { text: 'JCB', value: 'JCB' },
        { text: 'Diners', value: 'Diners' },
        { text: 'Discover', value: 'Discover' },
        { text: 'Hipercard', value: 'Hipercard' },
        { text: 'Hiper', value: 'Hiper' },
      ],
      disableParcelamento: true,
      reservationReasonJustification: '',
      newUser: false,
      blockScreen: false,
      showInstallments: false,
      vehicles: [],
      clients: [],
      reservationReason: [],
      creditCards: [],
      parcelamento: [1, 2, 3, 4, 5],
      newUserModel: {},
      clientModel: {},
      userModel: {},
      vehicleModel: {},
      creditCardModel: {},
      cupomModel: '',
      vehicleRequestModel: {},
      vehicleRequestEstimative: {},
      configurations: {},
      isLoadingClient: false,
      showJustification: false,
      isLoadingReservationReason: false,
      isLoadingUser: false,
      deposito: false,
      reservationReasonSelected: null,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      price_km: 0,
      price_hour: 0,
      free_km: 0,
      insurance_paid: false,
      insuranceTax: '',
    };
  },
  props: {
    clientId: {
      required: false,
      type: Number,
    },
  },
  methods: {
    convertMoneyToInteger(value) {
      if (typeof value != 'string') {
        return 0;
      }
      while (value.includes('.') || value.includes(',')) {
        value = value.replace('.', '').replace(',', '');
      }
      return Number.parseInt(value);
    },
    selecionaMetodoDePagamento() {
      if (this.creditCardModel.id) {
        this.deposito = false;
        this.disableParcelamento = false;
        this.vehicleRequestModel.installments = 1;
      } else {
        this.disableParcelamento = true;
        this.vehicleRequestModel.installments = null;
        this.deposito = true;
      }
    },
    selecionaTipoReserva() {
      this.reservationReasonJustification = '';
      this.showJustification =
        this.vehicleRequestModel.reservationReason.allow_justification;
    },
    async selectVehicle() {
      await this.calculateEstimative();

      this.price_hour = this.vehicleRequestEstimative.vehicleRequestPriceInCents / 100;
      this.price_km = this.vehicleModel.price_km / 100;
      this.insuranceTax =
        'Aderir ao seguro de R$: ' +
        NumberHelper.formatPrice(this.vehicleModel.insurance_tax);
    },
    selectUser(value) {
      this.userModel = value;
      let clienteSelecionado = this.clients.filter(
        (v) => v.id == value.clientUser_client_id
      );
      this.clientModel =
        clienteSelecionado.length > 0 ? clienteSelecionado[0] : {};
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    async validateFields() {
      try {
        this.blockScreen = true;

        if (!this.clientModel.id) {
          throw new Error('Cliente não selecionado');
        } else if (!this.userModel.id) {
          throw new Error('Usuário não selecionado');
        } else if (!this.vehicleRequestModel.begin_date) {
          throw new Error('Data inicial não selecionada');
        } else if (!this.vehicleRequestModel.end_date) {
          throw new Error('Data final não selecionada');
        }

        this.configurations =
          await this.configurationController.getAllConfigurationByClientId(
            this.clientModel.id
          );

        await this.getReservationInfos();
      } catch (error) {
        return this.$awn.alert(error.message);
      } finally {
        this.blockScreen = false;
      }
    },
    validateBeforeCreate() {
      try {
        if (this.clientModel.id === null || this.clientModel.id === undefined) {
          throw new Error('Cliente não selecionado');
        } else {
          this.newUser = true;
        }
      } catch (error) {
        return this.$awn.alert(error.message);
      }
    },
    cleanFields() {
      this.newUser = false;
      this.clientModel = {};
      this.userModel = {};
      this.newUserModel = {};
      this.vehicleRequestModel = {};
      this.vehicleModel = {};
      this.creditCardModel = {};
      this.vehicleRequestEstimative = {};
      this.clients = [];
      this.cupomModel = '';
      this.price_km = 0;
      this.price_hour = 0;
      this.deposito = false;
      this.free_km = false;
      this.creditCardModel = {};
      this.parcelamento = [];
      this.aprove_insurance_tax = false;
      this.insurance_tax = '';
      this.reservationReasonJustification = '';
    },

    async getReservationInfos() {
      try {
        this.vehicles = await this.vehicleController.getVehiclesAvaliablesByAdm(
          this.vehicleRequestModel.begin_date,
          this.vehicleRequestModel.end_date,
          this.clientModel.id
        );

        this.creditCards = await this.creditCardController.getAllByUserId(
          this.userModel.id,
          true
        );
        this.creditCards.unshift({ nickname: 'Sem cartão', id: null });
        // this.creditCards.push({ nickname: 'Depósito', id: 0 });
      } catch (error) {
        return this.$awn.alert(error.message);
      }
    },
    async calculateEstimative() {
      await this.vehicleRequestController
        .getPricePreview({
          begin_date: this.vehicleRequestModel.begin_date,
          end_date: this.vehicleRequestModel.end_date,
          vehicle_id: this.vehicleModel.id,
          user_id: this.userModel.id,
          client_id: this.clientModel.id,
          coupon: null,
          promotion_id: null,
        })
        .then((res) => (this.vehicleRequestEstimative = res))
        .catch((error) => {
          this.$awn.alert(error.body.message);
        });
    },
    async registerNewUser() {
      try {
        this.blockScreen = true;

        //manter a interface de cadastro de cliente já existente no back-end
        const user = await this.userController.createByAdm({
          cpf: this.newUserModel.cpf,
          drive_livence: this.newUserModel.cnh,
          email: this.newUserModel.email,
          hasForPasswordChange: true,
          name: this.newUserModel.userName,
          password: this.newUserModel.password,
          clientsUser: [{ value: this.clientModel.id }],
          profile_id: 2,
          approved: true,
        });

        if (user.ok) {
          this.cleanFields();
          return this.$awn.success('Usuário cadastrado com sucesso.');
        } else {
          return this.$awn.alert(`Erro ao cadastrar usuário. ${user.message}`);
        }
      } catch (error) {
        return this.$awn.alert(error.message);
      } finally {
        this.blockScreen = false;
      }
    },

    centsToReal2(cents) {
      cents = (cents / 100).toFixed(2).replace('.', ',');
      return cents;
    },

    async createReservation() {
      this.blockScreen = true;
      let reservation_value = NumberHelper.convertMoneyToInteger(
        String(this.price_hour)
      );

      let priceKmFormated = NumberHelper.convertMoneyToInteger(
        String(this.price_km)
      );
      debugger;
      if (
        this.clientModel.id == null ||
        this.userModel.id == null ||
        this.vehicleModel.id == null ||
        (!this.deposito && this.creditCardModel.id == null) ||
        this.vehicleRequestModel.reservationReason.id == null
      ) {
        this.$awn.alert('Preencha os campos obrigatórios!');
      } else {
        let data = {
          client_id: this.clientModel.id,
          user_id: this.userModel.id,
          begin_date: this.vehicleRequestModel.begin_date,
          end_date: this.vehicleRequestModel.end_date,
          vehicle_id: this.vehicleModel.id,
          reservation_value: reservation_value,
          price_km: priceKmFormated,
          card_id: this.creditCardModel.id,
          installments: this.vehicleRequestModel.installments,
          paymentMethod: { type: this.deposito ? 'deposit' : 'credit' },
          free_km: Number.parseInt(this.free_km),
          insurance_paid: this.insurance_paid,
          reservation_reason_id: this.vehicleRequestModel.reservationReason.id,
          reservation_reason_justification: this.reservationReasonJustification,
        };

        await this.vehicleRequestController
          .createFreeByAdm(data)
          .then((value) => {
            this.$awn.success('Reserva realizada com sucesso.');
            this.cleanFields();
          })
          .catch((error) => {
            this.$awn.alert(`${error.message}`);
            this.cleanFields();
          });
      }

      this.blockScreen = false;
    },
    async searchClients() {
      try {
        // Clients have already been loaded or Items have already been requested
        if (this.clients.length > 0 || this.isLoadingClient) return;

        this.isLoadingClient = true;
        this.clients = await this.clientController.getAllClients();
      } catch (error) {
        return this.$awn.alert('Erro ao obter clientes');
      } finally {
        this.isLoadingClient = false;
      }
    },
    async searchReservationReason() {
      try {
        if (
          this.reservationReason.length > 0 ||
          this.isLoadingReservationReason
        )
          return;

        this.isLoadingReservationReason = true;
        this.reservationReason =
          await this.vehicleRequestController.getReservationReason();
      } catch (error) {
        return this.$awn.alert('Erro ao obter tipo de reservas');
      } finally {
        this.isLoadingReservationReason = false;
      }
    },
    select_insurance_tax() {

      let currentReserveValue = parseInt(this.price_hour);

      if (this.insurance_paid == false) {
        this.insurance_paid = !this.insurance_paid;
        this.price_hour = currentReserveValue + this.vehicleModel.insurance_tax / 100
      } else {
        this.insurance_paid = !this.insurance_paid;
        this.price_hour = (currentReserveValue - this.vehicleModel.insurance_tax / 100)
      }
    },
  },
  filters: {
    formatPrice(price) {
      return NumberHelper.centsToReal(price);
    },
  },
  computed: {
    clientItems() {
      return this.clients.map((client) => {
        return {
          id: client.id,
          name: client.name,
        };
      });
    },
    reservationReasonItems() {
      return this.clients.map((reservationReason) => {
        return {
          id: reservationReason.id,
          name: reservationReason.name,
          allowJustification: reservationReason.allow_justification,
        };
      });
    },
  },
};
</script>

<style scoped>
.inputs {
  border: 1px solid grey;
  border-radius: 3px;
}

.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}
</style>
